var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7254 21.2536C13.4459 21.5331 13.0668 21.6901 12.6714 21.6901C12.2761 21.6901 11.897 21.5331 11.6174 21.2536L4.90884 14.545C4.62936 14.2654 4.47235 13.8863 4.47235 13.491C4.47235 13.0957 4.62936 12.7166 4.90884 12.437L11.6174 5.72839C11.8986 5.45683 12.2752 5.30657 12.6661 5.30996C13.057 5.31336 13.4309 5.47014 13.7073 5.74655C13.9837 6.02296 14.1405 6.39687 14.1439 6.78775C14.1473 7.17864 13.997 7.55522 13.7254 7.83639L9.68984 12.0002H23.8525C24.2478 12.0002 24.627 12.1573 24.9066 12.4368C25.1862 12.7164 25.3433 13.0956 25.3433 13.491C25.3433 13.8864 25.1862 14.2656 24.9066 14.5452C24.627 14.8247 24.2478 14.9818 23.8525 14.9818H9.68984L13.7254 19.1456C14.0049 19.4252 14.1619 19.8043 14.1619 20.1996C14.1619 20.5949 14.0049 20.974 13.7254 21.2536Z",
    fill: "#2B6ED5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackarrow);
export default __webpack_public_path__ + "static/media/backarrow.f35fb93af93a1281d241fc2a8b1a5b85.svg";
export { ForwardRef as ReactComponent };